export default __webpack_public_path__ + "static/media/IAMSmart_scanPage.21be71de.jpg";